export function useOpenReplay() {
  const { $tracker } = useNuxtApp();

  const openReplayTracker = () => {
    return $tracker;
  };

  return {
    openReplayTracker,
  };
}
